var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74689 14.1966L17.9378 4.00574C18.3527 3.5908 18.3527 2.9269 17.9378 2.51196L16.2448 0.819016C15.8299 0.404078 15.166 0.404078 14.751 0.819016L7 8.57005L3.49793 5.06798C3.08299 4.65304 2.41909 4.65304 2.00415 5.06798L0.311203 6.76092C-0.103734 7.17586 -0.103734 7.83976 0.311203 8.2547L6.25311 14.1966C6.66805 14.6115 7.33195 14.6115 7.74689 14.1966Z",
    fill: "#57AC2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.4fadd2a308303a6591a46d99c14d1094.svg";
export { ForwardRef as ReactComponent };